
<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    title="迁出授权码"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="40%"
    top="10vh"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
  >
    <el-form :model="item" ref="itemform" label-width="120px" :rules="rules">
      <el-form-item label="目标合同" prop="ContractID">
        <select2
          style="width: 100%"
          v-model="item.ContractID"
          :url="exceptself"
          placeholder="请选择合同"
          no-data-text="无合同"
          :emptyValue="0"
        ></select2>
      </el-form-item>
    </el-form>
    <el-table
      :data="itemList"
      v-loading="loading"
      @select="handleSelectionChange"
      @select-all="handleSelectionChange"
      ref="multipleTable"
    >
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * (pager.page)).toString().length * 12)"
      ></el-table-column>
      <el-table-column prop="Station.Name" label="站点名称"></el-table-column>
      <el-table-column type="selection" checked="true"></el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button
        type="primary"
        @click="onSubmit"
        :disabled="submitting || !multipleSelection.length"
      >
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      rowData: {},
      itemList: [],
      loading: false,
      submitting: false,
      multipleSelection: [],
      item: {
      },
      rules: {
        ContractID: [
          { required: true, message: '合同不能为空', trigger: 'blur' },
        ],
      },
      versionUrl: '',
      exceptself: '',
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  watch: {
    'item.SoftwareID': {
      handler() {
        this.versionUrl = `version/${this.item.SoftwareID}`;
      },
    },
  },
  methods: {
    onOpen() {
      this.rowData = _.clone(this.value);
      this.getItemList();
      this.exceptself = `contract/${this.$route.params.ID}/exceptself`;
    },
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
      this.$refs.itemform.resetFields();
      this.item = {};
      this.multipleSelection = [];
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    getItemList() {
      this.loading = true;
      this.$axios
        .get(`contract/${this.$route.params.ID}/migrate/stationshow`, { params: {
          ...this.pager,
        } })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, 'size', 'page', 'total');
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSelectionChange(list) {
      this.multipleSelection = [];
      list.forEach((element) => {
        this.multipleSelection.push(element.StationID);
      });
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit('input', this.item);
        const itemData = { ...this.item };
        itemData.SIDS = this.multipleSelection;
        // 保存的操作
        this.$axios
          .request({
            url: `/contract/${this.$route.params.ID}/migratecontract`,
            method: 'post',
            data: itemData,
          })
          .then(() => {
            this.$message.success('更新成功');
            this.submitting = false;
            this.$emit(itemData.ID ? 'form:updated' : 'form:created', true);
            this.$emit('form:saved', true);
            this.$emit('update:visible', false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
            this.$emit(itemData.ID ? 'form:updated' : 'form:created', false);
            this.$emit('form:saved', false);
          });
      });
    },
  },
};
</script>
